import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import {
  NG_DOC_DEFAULT_PAGE_PROCESSORS,
  NG_DOC_DEFAULT_PAGE_SKELETON,
  NgDocDefaultSearchEngine,
  provideMainPageProcessor,
  provideNgDocApp,
  providePageSkeleton,
  provideSearchEngine,
} from '@ng-doc/app';
import { NG_DOC_ROUTING, provideNgDocContext } from '@ng-doc/generated';
import { provideMIconsConfig } from 'projects/m-ui/components/m-icons/src/m-icons.provider';
import { AppComponent } from 'src/app/app.component';

import { environment } from './environments/environment';
import { provideMatFormFields } from '@metromobilite/m-ui/utils/m-providers/src/m-providers';
import { provideMIcons } from '@metromobilite/m-ui/components/m-icon/src/providers/m-icon.provider';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    // Provide context of the generated documentation
    provideNgDocContext(),
    // Provide default configuration for the documentation app
    provideNgDocApp({
      shiki: {
        themes: [import('shiki/themes/github-dark.mjs'), import('shiki/themes/github-light.mjs')],
        theme: {
          dark: 'github-dark',
          light: 'github-light',
        },
      },
    }),
    provideMIconsConfig(),
    provideMIcons(),
    provideMatFormFields(),
    provideSearchEngine(NgDocDefaultSearchEngine),
    providePageSkeleton(NG_DOC_DEFAULT_PAGE_SKELETON),
    provideMainPageProcessor(NG_DOC_DEFAULT_PAGE_PROCESSORS),
    // Provide animations
    provideAnimations(),
    // Provide HttpClient with interceptors (NgDoc uses interceptors)
    provideHttpClient(withInterceptorsFromDi()),
    // Add generated routes to the application
    provideRouter(
      [{ path: '', redirectTo: '/getting-started/what-is', pathMatch: 'full' }, ...NG_DOC_ROUTING],
      // Enable anchor scrolling
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      })
    ),
    provideExperimentalZonelessChangeDetection(),
    provideMatFormFields(),
  ],
}).catch(err => console.error(err));
